import polyglotI18nProvider from "ra-i18n-polyglot";
import de from "./de";
import en from "./en";
import fr from "./fr";

export const i18nProvider = polyglotI18nProvider((langCode) => {
    if (langCode && langCode !== "fr") return en;
    return fr;
}, "fr");